import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PrimaryBlueButton,
  SecondaryGrayButton
} from "@velaro/velaro-component-lib";
import { use } from "i18next";
import React, { useMemo } from "react";

interface Props {
  show: boolean;
  onClose(): void;
  onCreate(name: string): Promise<void>;
  saving: boolean;
}

export default function CreateModal(props: Props) {
  const [name, setName] = React.useState("");

  const handleCreate = async () => {
    await props.onCreate(name);
    setName("");
    props.onClose();
  };

  const disableCreate = useMemo(() => {
    return name.trim() === "";
  }, [name]);

  return (
    <Modal show={props.show} maxWidth="max-w-[600px]">
      <ModalHeader
        title="Create New Chat Window"
        onClose={() => props.onClose()}
      />
      <ModalBody>
        <div className="w-full border-t border-slate-300 pt-4">
          <div className="text-slate-800 text-sm font-medium">Name</div>
          <div className="text-slate-500 text-sm font-normal">
            Assign a name to your chat window for internal use (invisible to
            users).
          </div>
          <input
            id="name"
            name="name"
            type="text"
            className="input w-full mt-2 mb-6"
            autoFocus
            placeholder="Enter chat window name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="flex justify-end gap-4">
          <SecondaryGrayButton label="Cancel" onClick={() => props.onClose()} />
          <PrimaryBlueButton
            label={props.saving ? "Creating..." : "Create"}
            onClick={() => handleCreate()}
            disabled={disableCreate || props.saving}
          />
        </div>
      </ModalFooter>
    </Modal>
  );
}
